class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.productInfoElement = null;
    this.buyButtonElement = null;
    this.stickyBarElement = null;
    this.addToCartButton = null;
    this.stickyAddToCartButton = null;
    this.observer = null;
    this.threshold = 0;
    this.scrollDirection = 'down';
    this.lastScrollTop = 0;
    this.buttonPosition = 0;
    this.isButtonPassed = false;
  }

  connectedCallback() {
    const sectionId = this.dataset.section;
    this.productInfoElement = document.getElementById(`ProductInfo-${sectionId}`);
    this.buyButtonElement = document.getElementById(`ProductSubmitButton-${sectionId}`);
    this.stickyBarElement = document.getElementById(`sticky-add-to-cart-${sectionId}`);
    this.addToCartButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
    this.stickyAddToCartButton = document.getElementById(`StickyAddToCartButton-${sectionId}`);

    if (!this.buyButtonElement || !this.stickyBarElement || !this.stickyAddToCartButton) return;

    // Check if sticky bar is disabled
    if (this.dataset.disabled === 'true') return;

    // Get initial button position
    this.updateButtonPosition();
    
    this.setupScrollListener();
    this.setupEventListeners();
    
    // Update button position on window resize
    window.addEventListener('resize', this.updateButtonPosition.bind(this));
  }

  updateButtonPosition() {
    if (this.buyButtonElement) {
      const rect = this.buyButtonElement.getBoundingClientRect();
      this.buttonPosition = rect.top + window.pageYOffset + rect.height;
    }
  }

  setupScrollListener() {
    window.addEventListener('scroll', () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Determine scroll direction
      if (scrollTop > this.lastScrollTop) {
        this.scrollDirection = 'down';
      } else {
        this.scrollDirection = 'up';
      }
      
      // Check if we're below the button
      this.isButtonPassed = scrollTop > this.buttonPosition;
      
      // Check if we've reached the bottom of the page
      const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;
      
      // Show sticky bar when below the button but not at the bottom of the page
      if (this.isButtonPassed && !isAtBottom) {
        this.stickyBarElement.setAttribute('aria-hidden', 'false');
      } else {
        this.stickyBarElement.setAttribute('aria-hidden', 'true');
      }
      
      // Save current scroll position
      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }, { passive: true });
  }

  setupEventListeners() {
    this.stickyAddToCartButton.addEventListener('click', () => {
      // Add loading state
      this.stickyAddToCartButton.classList.add('loading');
      this.stickyAddToCartButton.setAttribute('disabled', true);
      
      // Show the loading spinner
      const spinner = this.stickyAddToCartButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      
      // If main form add to cart button exists, click it
      if (this.addToCartButton) {
        this.addToCartButton.click();
        
        // Reset button state after a delay (in case the form submission is handled elsewhere)
        setTimeout(() => {
          this.stickyAddToCartButton.classList.remove('loading');
          this.stickyAddToCartButton.removeAttribute('disabled');
          // Hide the spinner again
          if (spinner) spinner.classList.add('hidden');
        }, 2000);
      } else {
        // Otherwise handle adding to cart directly
        this.addToCart();
      }
    });
  }

  addToCart() {
    const productId = this.stickyAddToCartButton.dataset.productId;
    const variantId = this.stickyAddToCartButton.dataset.variantId;
    
    if (!productId || !variantId) return;

    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      // Handle successful add to cart
      // Refresh cart drawer if exists
      if (typeof window.refreshCart === 'function') {
        window.refreshCart();
      }
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    })
    .finally(() => {
      this.stickyAddToCartButton.classList.remove('loading');
      this.stickyAddToCartButton.removeAttribute('disabled');
      // Hide the spinner
      const spinner = this.stickyAddToCartButton.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateButtonPosition);
    window.removeEventListener('scroll', this.setupScrollListener);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart); 